import { Component, Inject, Vue } from 'vue-property-decorator';

import store from '../store';
import { ERROR_TYPES } from "@/config/error-types";
import RegistrationService from "@/apis/registration";
import RequestHelper from '@/helpers/request';
import * as franchise from "@/apis/franchise";
import * as service from "@/apis/service";
import * as catalog from "@/apis/catalog";

export const updatePrimaryFranchiseByPostalCode = async function (postalCode: any) {

	const requestData = {
		securityToken: store.getters.token,
		zip: postalCode,
	};
	const response = await franchise.getFranchiseByZip(requestData)
	const { data } = response
	if ("errNo" in data && data.errNo === 0) {
		if ("Franchise" in data && data.Franchise.length) {
			const [firstFranchise] = data.Franchise;
			const { franchiseID } = firstFranchise;
			store.commit('updateFranchiseID', franchiseID);
		} else {
			throw new Error("Can't find franchise");
		}
	} else {
		let errMsg = "errMsg" in data ? data.errMsg : "Service is unavailable";
		if (data.Errors && data.Errors.length) {
			errMsg = data.Errors[0].errMsg;
		}
		throw new Error(errMsg);
	}
}
export const checkSecurityToken = async function () {

	if (!store.getters.token) {
		await updateSecurityToken();
		return;
	}
	const requestData = {
		securityToken: store.getters.token
	};
	let response = await service.checkSecurityToken(requestData);
	const data = response.data;
	if ('errNo' in data && data.errNo !== 0) {
		let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
		if (data.Errors && data.Errors.length) {
			const [firstError] = data.Errors;
			({ errMsg } = firstError);
		}
		throw new Error(errMsg);
	} else {
		await updateSecurityToken();
	}
}
export const updateSecurityToken = async function () {
	const response = await service.login();
	const data = response.data;
	if ("errNo" in data && data.errNo === 0) {
		const token = data.securityToken;

		store.commit('updateToken', token);
	} else {
		let errMsg = "errMsg" in data ? data.errMsg : "Service is unavailable";
		if (data.Errors && data.Errors.length) {
			errMsg = data.Errors[0].errMsg;
			console.error(`errorupdateSecurityToken ${errMsg}`);
		}
		throw new Error(errMsg);
	}
}

export const findExistingContactEmail = async function (email: any) {
	const requestData = {
		securityToken: store.getters.token,
		email: email,
	};
	let contact = null;
	const response = await service.findExistingContactByEmail(requestData)
	const { data } = response
	if ("errNo" in data && data.errNo === 0) {
		if ('Contacts' in data) {
			for (let i = 0; i < data.Contacts.length; i += 1) {
				if (data.Contacts[i].isActive !== 'False') {
					contact = data.Contacts[i];
					break;
				}
			}
		} else {
			throw new Error("Can't find contact");
		}
		return contact
	} else {
		let errMsg = "errMsg" in data ? data.errMsg : "Service is unavailable";
		if (data.Errors && data.Errors.length) {
			errMsg = data.Errors[0].errMsg;
		}
		throw new Error(errMsg);
	}
}
export const setPasswordResetKey = async function (email: any) {

	try {
		const contact = await findExistingContactEmail(email)

		const contactId = contact.objectID;
		const requestData = {
			securityToken: store.getters.token,
			contactId,
		};
		await service.setResetPasswordKey(requestData);

	} catch (e) {
		throw new Error(e.message);
	}
}

export const validateResetPasswordKey = async function (payload: any) {

	const { resetKey, contactId } = payload;

	const requestData = {
		securityToken: store.getters.token,
		contactId,
		resetKey,
	};

	const response = await service.validateResetPasswordKey(requestData)
	const { data } = response;
	if ('errNo' in data && data.errNo !== 0) {
		let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
		if (data.Errors && data.Errors.length) {
			const [firstError] = data.Errors;
			({ errMsg } = firstError);
		}
		throw new Error(errMsg);
	}
}

export const setPassword = async function (request: any) {
	const requestData = {
		securityToken: request.securityToken,
		clientId: request.clientId,
		contactId: request.contactId,
		login: request.login,
		password: request.password,
	};

	const response = await service.setPassword(requestData)
	const { data } = response;
	if ('errNo' in data && data.errNo !== 0) {
		let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
		if (data.Errors && data.Errors.length) {
			const [firstError] = data.Errors;
			({ errMsg } = firstError);
		}
		throw new Error(errMsg);
	}
}

export const loadPriceItems = async function () {
	const requestData = {
		securityToken: store.getters.token,
		zipCode: store.getters.postcode,
	};
	const priceItemsFromServer = await catalog.getCatalogList(requestData)

	const { data } = priceItemsFromServer;
	if ('errNo' in data && data.errNo !== 0) {
		let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
		if (data.Errors && data.Errors.length) {
			const [firstError] = data.Errors;
			({ errMsg } = firstError);
		}
		throw new Error(errMsg);
	} else {
		if (data.PriceItems && data.PriceItems.length !== 0) {
			const priceItemDay = data.PriceItems.find((item: any) => (item.serviceID == 182 && item.isActive === true))
			const priceItem = data.PriceItems.find((item: any) => (item.serviceID == store.getters.serviceID && item.isActive === true))
			if (priceItem && priceItemDay) {
				return {priceItem,priceItemDay}
			}
			else {
				throw new Error('can not find priceItems');
			}
		}
		else {
			throw new Error('can not find priceItems');
		}
	}
}

//   export const loadPriceList = async function() {
//   const requestDataForFetchingPriceLists = {
//     securityToken: store.getters.token,
//   };
//
//  const priceLists = await catalog.getPriceLists(requestDataForFetchingPriceLists)
//
// const { data } = priceLists;
// if ('errNo' in data && data.errNo !== 0) {
//     let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
//     if (data.Errors && data.Errors.length) {
//       const [firstError] = data.Errors;
//       ({ errMsg } = firstError);
//     }
//     throw new Error(errMsg);
//   }
//  if (!priceLists.data.PriceLists || priceLists.data.PriceLists.length === 0) {
//     throw new Error('AREA UNAVAILABLE');
//   }
//
//  const selectedServiceTypeId = 11;
//   const priceListEntity = priceLists.data.PriceLists.find(
// 	 //@ts-ignore
//     (priceList) => +priceList.serviceTypeID === selectedServiceTypeId,
//   );
//
//   if (!priceListEntity) {
//     throw new Error('AREA UNAVAILABLE');
//   }
//
//   store.commit('updatePriceListID', priceListEntity.priceListID);
// }


export const fetchUserData = async function (contactId: any) {
	const requestData = {
		securityToken: store.getters.token,
		contactId: contactId,
	};

	const client = await service.getClientByContactId(requestData);
	const { data } = client;
	if ('errNo' in data && data.errNo !== 0) {
		let errMsg = 'errMsg' in data ? data.errMsg : 'Service is unavailable';
		if (data.Errors && data.Errors.length) {
			const [firstError] = data.Errors;
			({ errMsg } = firstError);
		}
		throw new Error(errMsg);
	}
	const clientEntity = data.Relations.find(
		//@ts-ignore
		r => r.relationType === 'client',
	);

	if (clientEntity === undefined) {
		const error = 'Can\'t find a client';
		throw new Error(error);
	}

	const clientId = clientEntity.objectID;
	// @ts-ignore
	const loginField = data.Fields.find(field => field.fieldID === 6184);
	const login = loginField.fieldValue;
	return {login: login, clientId: clientId}
}
